import { useState } from "react";

const SECTIONS = [
  {
    id: "about",
    title: "🌾 農援とは？",
    content: [
      {
        type: "text",
        body: "農援は「国や県が用意している返済不要のお金のサポート（補助金）」を農家さんが簡単に見つけられるようにするサービスです。",
      },
      {
        type: "list",
        items: [
          "農協が積極的に案内しない補助金も含めて探せます",
          "AIが農家さんの状況に合わせて補助金を絞り込みます",
          "申請のサポートは提携行政書士が担当します",
          "診断・AI相談は無料でご利用いただけます",
        ],
      },
    ],
  },
  {
    id: "subsidy",
    title: "💰 補助金って何？",
    content: [
      {
        type: "qa",
        q: "補助金とは？",
        a: "国・都道府県・市区町村が農業者を支援するために支給するお金です。返済不要です。例えば「トラクターを買うときに費用の半額を国が出してくれる」という形で使えます。",
      },
      {
        type: "qa",
        q: "誰でも使えますか？",
        a: "個人農家・農業法人・新規就農者など、多くの農業者が対象です。ただし補助金ごとに「認定農業者であること」「青色申告していること」などの要件があります。",
      },
      {
        type: "qa",
        q: "農協に相談すれば良くないですか？",
        a: "農協は農業機械を販売する立場でもあるため、補助金申請を積極的に案内しないケースがあります。農援では農協が案内しない補助金も含めて、農家ファーストで情報を提供します。",
      },
      {
        type: "warn",
        body: "⚠️ 重要：補助金は機械・施設を「購入前」に申請が必要です。購入・契約後は申請できない場合がほとんどです。",
      },
    ],
  },
  {
    id: "howto",
    title: "📋 詳しい使い方",
    content: [
      {
        type: "step",
        steps: [
          {
            n: "1",
            title: "🏠 ホーム画面でやりたいことを選ぶ",
            desc: "「農機を新しくしたい」「農業を始めたい」などボタンをタップ。補助金を知らなくてもOKです。やりたいことを選ぶだけで始められます。",
          },
          {
            n: "2",
            title: "💬 AIに相談する",
            desc: "農業でやりたいこと・困っていることを話すと、AIが補助金の候補を提案します。「わからない」「大体」という答えでも大丈夫です。",
          },
          {
            n: "3",
            title: "📋 補助金診断で候補を絞る",
            desc: "10問の診断で、あなたの状況に合った補助金をスコア順に表示します。上位5件が「おすすめ」として表示されます。",
          },
          {
            n: "4",
            title: "👨‍💼 行政書士に相談する",
            desc: "補助金の詳細画面から行政書士への相談シートを作成できます。事前ヒアリング（3問〜）に答えるとシートが自動生成され、コピーして行政書士に送れます。",
          },
        ],
      },
    ],
  },
  {
    id: "lawyer",
    title: "👨‍💼 行政書士について",
    content: [
      {
        type: "qa",
        q: "費用はかかりますか？",
        a: "多くの場合「成功報酬型」です。補助金が採択されなければ費用はかかりません。採択された場合、補助金額の10〜15%程度の報酬をお支払いいただく形が一般的です。",
      },
      {
        type: "qa",
        q: "何を準備すればいいですか？",
        a: "①投資したい機械・施設の見積書、②認定農業者かどうかの確認、③青色申告しているか確認、の3点を用意できると相談がスムーズです。",
      },
      {
        type: "qa",
        q: "農協より詳しいですか？",
        a: "農業補助金に特化した行政書士は、農協では案内されない補助金も熟知しています。申請書類の作成・事業計画書の作り方もサポートします。",
      },
    ],
  },
  {
    id: "faq",
    title: "❓ よくある質問",
    content: [
      {
        type: "qa",
        q: "個人情報は安全ですか？",
        a: "行政書士への相談シートはあなたがコピーして送る形式です。自動送信はしません。名前・住所の入力は任意で、最低限の情報で使えます。",
      },
      {
        type: "qa",
        q: "診断結果は確実ですか？",
        a: "AI診断は参考情報です。「申請できる可能性があります」という案内であり、採択の保証はしません。最終的な申請可否は行政書士または各事務局にご確認ください。",
      },
      {
        type: "qa",
        q: "採択されなかったらどうなりますか？",
        a: "補助金の申請は不採択になる可能性があります。その場合、行政書士への成功報酬は発生しません（事前に確認してください）。翌年度以降に再申請できる場合もあります。",
      },
      {
        type: "qa",
        q: "農業を始める前でも使えますか？",
        a: "就農予定の方向けの補助金（就農準備資金など）もあります。「これから農業を始めたい・継ぎたい」を選んで診断してみてください。",
      },
    ],
  },
];

export default function HelpScreen({ onClose }) {
  const [openSection, setOpenSection] = useState(null);

  return (
    <div className="screen">
      <button className="back-btn" onClick={onClose}>← 戻る</button>
      <h2 className="screen-title">📖 使い方・よくある質問</h2>

      <div style={{ display:"flex", flexDirection:"column", gap:"0.5rem" }}>
        {SECTIONS.map((sec) => (
          <div key={sec.id} style={{ border:"1px solid #e0e0e0", borderRadius:12, overflow:"hidden" }}>
            {/* アコーディオンヘッダー */}
            <button
              onClick={() => setOpenSection(openSection === sec.id ? null : sec.id)}
              style={{ width:"100%", display:"flex", justifyContent:"space-between", alignItems:"center", padding:"0.9rem 1rem", background: openSection === sec.id ? "#f1f8e9" : "#fff", border:"none", cursor:"pointer", fontSize:"0.92rem", fontWeight:700, color:"#1a4a2e" }}
            >
              {sec.title}
              <span style={{ fontSize:"1.1rem", color:"#2e7d32" }}>{openSection === sec.id ? "▲" : "▼"}</span>
            </button>

            {/* アコーディオン本文 */}
            {openSection === sec.id && (
              <div style={{ padding:"0.75rem 1rem 1rem", borderTop:"1px solid #e8f5e9" }}>
                {sec.content.map((block, i) => (
                  <div key={i}>
                    {block.type === "text" && (
                      <p style={{ fontSize:"0.85rem", color:"#444", lineHeight:1.8, marginBottom:"0.75rem" }}>{block.body}</p>
                    )}
                    {block.type === "list" && (
                      <ul style={{ paddingLeft:"1.2rem", margin:"0 0 0.75rem" }}>
                        {block.items.map((item, j) => (
                          <li key={j} style={{ fontSize:"0.85rem", color:"#444", lineHeight:1.8, marginBottom:"0.3rem" }}>{item}</li>
                        ))}
                      </ul>
                    )}
                    {block.type === "qa" && (
                      <div style={{ marginBottom:"0.9rem" }}>
                        <div style={{ fontWeight:700, fontSize:"0.85rem", color:"#1a4a2e", marginBottom:"0.3rem" }}>Q. {block.q}</div>
                        <div style={{ fontSize:"0.83rem", color:"#555", lineHeight:1.7, background:"#f9fafb", borderRadius:8, padding:"0.6rem 0.85rem" }}>A. {block.a}</div>
                      </div>
                    )}
                    {block.type === "warn" && (
                      <div style={{ background:"#fff3e0", border:"1px solid #ff9800", borderRadius:10, padding:"0.75rem", marginBottom:"0.75rem", fontSize:"0.83rem", color:"#e65100", lineHeight:1.6 }}>
                        {block.body}
                      </div>
                    )}
                    {block.type === "step" && (
                      <div style={{ display:"flex", flexDirection:"column", gap:"0.75rem" }}>
                        {block.steps.map((step) => (
                          <div key={step.n} style={{ display:"flex", gap:"0.85rem", alignItems:"flex-start", background:"#f9fafb", borderRadius:10, padding:"0.85rem" }}>
                            <div style={{ minWidth:"2rem", height:"2rem", background:"#1a4a2e", color:"#fff", borderRadius:"50%", display:"flex", alignItems:"center", justifyContent:"center", fontWeight:800, fontSize:"0.9rem", flexShrink:0 }}>
                              {step.n}
                            </div>
                            <div>
                              <div style={{ fontWeight:700, fontSize:"0.85rem", color:"#1a4a2e", marginBottom:"0.3rem" }}>{step.title}</div>
                              <div style={{ fontSize:"0.78rem", color:"#666", lineHeight:1.6 }}>{step.desc}</div>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>

      {/* チュートリアルを再表示 */}
      <button
        onClick={() => { localStorage.removeItem("nouen_tutorial_done"); window.location.reload(); }}
        style={{ width:"100%", background:"none", border:"1px solid #ddd", color:"#888", borderRadius:10, padding:"0.75rem", marginTop:"1rem", fontSize:"0.82rem", cursor:"pointer" }}
      >
        🔄 最初のチュートリアルをもう一度見る
      </button>
    </div>
  );
}
